import {useQuery} from 'react-query';
import {getSponserList} from '.';

const useGetSponserList = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['sponsorList'],
    queryFn: getSponserList,
  });
  return {data, isLoading};
};

export default useGetSponserList;
